import React from "react";
import "./PublishingProcessTab.css";
import ProcessSteps from "../../Shared/ProcessSteps/ProcessSteps";
import { TextWithLineBreaks } from "../../../Components/TextWithLineBreaks";

const planningProcessSteps = [
  { title: "저자 원고 제안" },
  { title: "출판사 검토" },
  { title: "계약" },
  { title: "교정 및 교열" },
  {
    title: "디자인 및 편집",
    details: [
      {
        subtitle: "예상 편집 기간",
        items: [
          "일반 도서: 4-6개월",
          "전문서적: 6-8개월",
          "대형 기획: 8-12개월",
        ],
      },
    ],
  },
  { title: "검수" },
  { title: "도서 등록" },
  { title: "유통 및 마케팅" },
  { title: "판매 및 인세" },
];

function PublishingProcessTab() {
  return (
    <div className="publishing-process-tab">
      <div className="publishing-process-tab-title">기획 출판 과정</div>

      <div className="publishing-process-tab-desc">
        <TextWithLineBreaks
          text={"단계별 : 기획(1개월) → 집필(2-4개월) → 편집(2개월)"}
        />
      </div>

      <div className="steps-wrapper">
        <ProcessSteps steps={planningProcessSteps} />
      </div>
    </div>
  );
}

export default PublishingProcessTab;
